// extracted by mini-css-extract-plugin
export default {"close":"CloseButton_close__sl4UO","close-diagonal__left":"CloseButton_close-diagonal__left__xKnaA","close-diagonal__right":"CloseButton_close-diagonal__right__3Bt3I"};